import styled from 'styled-components';

import { Image } from '@zillow/constellation';

export const StyledImage = styled(Image)`
    height: 100px;
`;
